module.exports = __webpack_public_path__ + "static/media/generatefile.fc5f4401.svg";